import { render } from "./App.vue?vue&type=template&id=fe18acac"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fe18acac&lang=less"

import exportComponent from "E:\\Object\\xin_poc_mini\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__